import { Component, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ShotApprovalStatus } from 'src/app/components/company/models/new/shot';

@Component({
	selector: 'bt-image-preview-modal',

	standalone: false,
	templateUrl: './image-preview-modal.component.html',
	styleUrl: './image-preview-modal.component.scss'
})
export class ImagePreviewModalComponent {
	readonly #dialogRef = inject(MatDialogRef<ImagePreviewModalComponent>);
	readonly data = inject<any>(MAT_DIALOG_DATA);

	preview!: string;
	valid = false;

	ngOnInit() {
		this.preview = this.data.preview;
		this.validate(this.preview);
	}

	validate(src: string) {
		const img = new Image();
		img.onload = () => {
			this.valid = img.width === img.height;
		};
		img.src = src;
	}

	close() {
		this.#dialogRef.close();
	}

	confirm() {
		this.#dialogRef.close(true);
	}
}
